import GlobalNavigationShell from "components/v2/global-navigation-shell/GlobalNavigationShell";
import { getLoanCentricGlobalHeaderChrome } from "components/v2/global-header/getLoanCentricGlobalHeaderChrome";
import LoanCentricMobileDock from "components/v2/loan-centric-mobile-dock/LoanCentricMobileDock";
import LoanCentricSidebarNav from "components/v2/loan-centric-sidebar-nav/LoanCentricSidebarNav";
import useDesktopChecker from "hooks/useDesktopChecker";
import useTabletChecker from "hooks/useTabletChecker";
import ProfileSettings from "pages/dashboard/v2/shared/profile-settings/ProfileSettings";

/**
 *  Dedicated /settings route .
 * GlobalHeader title "Settings"; dock Settings tab active; ProfileSettings as page content.
 */
const SettingsShellLayout = () => {
  const isDesktop = useDesktopChecker();
  const isTablet = useTabletChecker();
  const isMobilePhone = !isDesktop && !isTablet;
  const headerChrome = getLoanCentricGlobalHeaderChrome({
    enabled: true,
    page: "settings",
  });

  return (
    <div className="dashboard-shell">
      <GlobalNavigationShell
        notificationsEnabled={false}
        shellContext="settings"
        hideFooter
        headerMode={headerChrome?.headerMode}
        headerTitle={headerChrome?.title}
        navSlot={!isMobilePhone ? <LoanCentricSidebarNav /> : undefined}
        navSlotPlacement="sidebar"
        mobileNavSlot={isMobilePhone ? <LoanCentricMobileDock /> : undefined}
      >
        <ProfileSettings />
      </GlobalNavigationShell>
    </div>
  );
};

export default SettingsShellLayout;
